export default function PHP_is_executable() {
  return (
    <div>
      <h1>PHP_is_executable</h1>
    </div>
  );
}
